import React from "react";
import { ButtonGroup, ToggleButton, Button } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import { BsFillBarChartFill, BsQuestionCircleFill } from "react-icons/bs";
import { MainSpace } from "../../common/constants";
import "../main.css";

export interface IProps extends WithTranslation {
  /**
   * 選択中ナビ項目
   */
  mode: number;
  /**
   * ナビ項目を選択した場合に呼び出します
   * @param mode - 選択したナビ項目
   */
  onSelect: (mode: number) => void;
  /**
   * ナビバーを開く場合はtrue
   */
  open: boolean;
}

class Navigation extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleOpenURL = this.handleOpenURL.bind(this);
  }

  handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.props.onSelect(parseInt(e.currentTarget.value));
  }

  handleOpenURL(url: string) {
    window.open(url);
  }

  render() {
    const { open, t } = this.props;
    const className = open ? "main-nav" : "main-nav-close";
    const project = open ? t("navigation_project") : "";
    const help = open ? t("navigation_help") : "";

    return (
      <nav className={className}>
        <ButtonGroup className="d-flex flex-column">
          <ToggleButton
            className="navi-menu-item"
            id="projects"
            type="checkbox"
            checked={this.props.mode === MainSpace.PROJECTS}
            value={MainSpace.PROJECTS}
            variant="outline-light"
            onChange={this.handleChange}
            size="lg"
          >
            <BsFillBarChartFill />
            {project}
          </ToggleButton>
        </ButtonGroup>
        <Button
          className="navi-menu-item-help"
          id="help"
          variant="outline-light"
          onClick={() => this.handleOpenURL(t("link_url_help"))}
          size="lg"
        >
          <BsQuestionCircleFill />
          {help}
        </Button>
      </nav>
    );
  }
}

export default withTranslation()(Navigation);
